import { EtdWiseDto } from "../dto/etd-wise.dto";
import { EtdWise } from "../entity/etd-wise-grid.entity";

export class EtdWiseAdapter {
    convertDtoToEntity(dtoObj: EtdWiseDto[], isUpdate: boolean = false): EtdWise[] {
        const entity :EtdWise[] = []
        for(const record of dtoObj){
            const entityObj = new EtdWise();
            entityObj.etdWiseId = record.etdWiseId;
            entityObj.saleOrderId = record.saleOrderId;
            entityObj.actualEdaDate = new Date(record.actualEdaDate);
            entityObj.revisedEdaDate = new Date(record.revisedEdaDate);
            entityObj.unitId = record.unitId;
            entityObj.createdUser = record.createdUser;
            entity.push(entityObj)
        }
        return entity
    }
    public convertEntityToDto(obj: EtdWise): EtdWiseDto {
        const dtoObj = new EtdWiseDto;

        dtoObj.etdWiseId = obj.etdWiseId;
        dtoObj.saleOrderId = obj.saleOrderId;
        dtoObj.actualEdaDate = obj.actualEdaDate;
        dtoObj.revisedEdaDate = obj.revisedEdaDate;
        dtoObj.unitId = obj.unitId;
        dtoObj.createdAt = obj.createdAt;
        dtoObj.updatedAt = obj.updatedAt;
        dtoObj.createdUser = obj.createdUser;
        dtoObj.updatedUser = obj.updatedUser;
        dtoObj.versionFlag = obj.versionFlag;
        return dtoObj;
    }

}